import parse from "html-react-parser";
import React from "react";

export const SafeHtmlParser = ({ htmlContent }) => {
	// Ensure we always have a string
	let correctedHtml = typeof htmlContent === "string" ? htmlContent : "";

	// Replace className with class if we have a string
	correctedHtml = correctedHtml.replace(
		/className\s*=\s*(".?"|'.?'|[^"'\s>]+)/g,
		"class=$1"
	);

	// Sanitize only in browser (no SSR)
	if (typeof window !== "undefined") {
		const DOMPurify = require("dompurify");
		correctedHtml = DOMPurify.sanitize(correctedHtml);
	}

	// Now parse the sanitized string
	const content = parse(correctedHtml || "");

	return <>{content}</>;
};
